<template>
    <pt-integral-goods-group-form ref="form" class="pt-integral-goods-group-form__withData" :is-edit="isEdit" :id="id" :form="groupDetail" :table-data="tableData"
    v-loading="detailLoading"></pt-integral-goods-group-form>
</template>

<script>
import PtIntegralGoodsGroupForm from './form'
export default {
  name: 'pt-integral-goods-group-form__withData',
  components: {
    'pt-integral-goods-group-form': PtIntegralGoodsGroupForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      groupDetail: {},
      tableData: [],
      detailLoading: false
    }
  },
  methods: {
    // 新建/编辑group的排序枚举和积分商品列表枚举的转换
    // 获取分组详情
    goodsGroupDetail () {
      this.detailLoading = true
      this.$store.dispatch('integralGoodsGroupDetail', this.id).then(data => {
        this.detailLoading = false
        this.groupDetail = data
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取积分商品分组信息失败')
      })
    },
    editApi (data) {
      this.$emit('submitLoad', true)
      this.$store.dispatch('integralGroupEdit', data).then(data => {
        this.$message.success('编辑积分商品分组成功')
        history.go(-1)
        this.$emit('submitLoad', false)
      }).catch(err => {
        this.$message.error(err || '编辑积分商品分组失败')
        this.$emit('submitLoad', false)
      })
    },
    new (data) {
      this.$emit('submitLoad', true)
      this.$store.dispatch('newIntegralGoodsGroup', data).then(data => {
        this.$message.success('新建积分商品分组成功')
        history.go(-1)
        this.$emit('submitLoad', false)
        // doing something ...
      }).catch(errorMessage => {
        this.$emit('submitLoad', false)
        this.$message.error(errorMessage || '新建积分商品分组失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        if (this.isEdit) {
          this.editApi(formValue)
        } else {
          this.new(formValue)
        }
      })
    },
    cancel () {
      history.go(-1)
    }
  },
  created () {
    if (this.isEdit) {
      this.goodsGroupDetail()
    }
  }
}
</script>
